import { useRef } from "react";

import i18next from "i18next";
import { IoAttachOutline, IoCloseOutline } from "react-icons/io5";

import { formatFileSize, supportAcceptAttribute, supportFilesHint } from "../utils";

import { FieldError, FieldHint, FileChip, FileChips, FilesBlock, TextButton } from "../style";

// Несколько файлов к сообщению: кнопка «Прикрепить», список выбранных с удалением, подсказка о лимитах из meta.
const SupportFilesInput = ({ files, onChange, limits, error, disabled }) => {
  const { t } = i18next;
  const inputRef = useRef(null);

  const handleChange = e => {
    const chosen = Array.from(e.target.files || []);
    // сброс, чтобы повторный выбор того же файла снова вызывал onChange
    e.target.value = "";

    if (chosen.length) onChange([...files, ...chosen]);
  };

  const removeFile = index => onChange(files.filter((_, fileIndex) => fileIndex !== index));

  return (
    <FilesBlock>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={supportAcceptAttribute(limits)}
        onChange={handleChange}
        disabled={disabled}
      />

      <div>
        <TextButton type="button" onClick={() => inputRef.current?.click()} disabled={disabled}>
          <IoAttachOutline />
          {t("support_files_add")}
        </TextButton>
        <FieldHint>{supportFilesHint(limits)}</FieldHint>
      </div>

      {files.length > 0 && (
        <FileChips>
          {files.map((file, index) => (
            <FileChip key={`${file.name}-${index}`}>
              <span>{file.name}</span>
              <small>{formatFileSize(file.size)}</small>
              <button type="button" onClick={() => removeFile(index)} title={t("support_remove")} disabled={disabled}>
                <IoCloseOutline />
              </button>
            </FileChip>
          ))}
        </FileChips>
      )}

      {error && <FieldError>{error}</FieldError>}
    </FilesBlock>
  );
};

export default SupportFilesInput;
